import { render, staticRenderFns } from "./CostStatisticsSkeleton.vue?vue&type=template&id=a1560f66"
var script = {}
import style0 from "./CostStatisticsSkeleton.vue?vue&type=style&index=0&id=a1560f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports